import { useAuth } from '../context/AuthContext';

const ImpersonationBanner = () => {
  const { user, logout } = useAuth();
  const impersonatorRaw = localStorage.getItem('impersonator');

  if (!impersonatorRaw) return null;

  let impersonatorEmail = impersonatorRaw;
  try {
    const parsed = JSON.parse(impersonatorRaw);
    if (parsed && typeof parsed === 'object' && parsed.email) {
      impersonatorEmail = parsed.email;
    }
  } catch {
    // impersonatorEmail stays as the raw string
  }

  const handleExit = async () => {
    const ok = window.confirm('Exit impersonation and return to your SuperAdmin session?');
    if (!ok) return;
    // Clear impersonation state — logout clears cookies and redirects to login
    localStorage.removeItem('impersonator');
    await logout();
  };

  return (
    <div role="alert" className="bg-violet-700 text-white px-8 py-2 flex justify-between items-center shadow-lg">
      <div className="flex items-center space-x-2">
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span className="text-sm font-bold">
          IMPERSONATION MODE
          {user?.email && (
            <> — Viewing as <span className="underline">{user.email}</span></>
          )}
          {user?.role && (
            <span className="font-normal"> · role {user.role}</span>
          )}
          {impersonatorEmail && (
            <span className="font-normal opacity-80"> · Initiated by {impersonatorEmail}</span>
          )}
        </span>
      </div>
      <button
        onClick={handleExit}
        className="bg-white text-violet-700 px-4 py-1 rounded-full text-xs font-black uppercase hover:bg-violet-50 transition-colors shrink-0"
      >
        Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
